import React, {useState, useEffect} from "react";
import formatter from "../../helpers/number_formatter";
import rider from "../../network/services/rider";
import {getUserPhoneNumber} from "../../helpers/authenticator";
import quick_models from "../../network/models/quick_models";

const RiderStats = () => {
    const [stats, setStats] = useState({});

    useEffect(() => {
        rider.getRiderStats(getUserPhoneNumber()).then(response => {
                setStats(response.data.data)
            }
        ).catch(error => {
        });
    }, []);


    let mergedStats = {...quick_models.riderStatsResponse, ...stats};

    return (
        <>
            <div className="row justify-content-center">
                <ul className="list-unstyled">
                    <li><h1 className="text-center">
                        GH{formatter.accounting.formatMoney(mergedStats.total_amount_payable, "¢ ")}
                    </h1></li>
                    <li className="text-center">
                        <small>Total Amount Collected</small>
                    </li>
                </ul>
            </div>
            <br/>
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card text-center">
                        <ul className="list-unstyled">
                            <li><h4>209</h4></li>
                            <li>
                                <hr/>
                            </li>
                            <li>
                                <small>Completed</small>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card text-center">
                        <ul className="list-unstyled">
                            <li><h4>{mergedStats.pending_orders}</h4></li>
                            <li>
                                <hr/>
                            </li>
                            <li>
                                <small>Pending</small>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card text-center">
                        <ul className="list-unstyled">
                            <li><h4>{mergedStats.orders_completed}</h4></li>
                            <li>
                                <hr/>
                            </li>
                            <li>
                                <small>Completed</small>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>);
};

export default RiderStats;
